var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReport = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.575 9.908c1.26.122 2.573.27 3.921.27 1.387 0 2.736-.156 4.028-.28.549-.053.974-.492.818-1.02-.43-1.448-1.722-3.367-1.722-3.367s1.285-1.825 1.718-3.24c.162-.526-.265-.965-.814-1.018-1.292-.124-2.64-.28-4.028-.28-1.348 0-2.661.148-3.92.27A1.163 1.163 0 0 0 3.52 2.395v6.36c0 .598.46 1.095 1.054 1.153Z",
  stroke: "#BE123C",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.522 15.071v-6",
  stroke: "#BE123C",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgReport;